<template>
  <el-container class="page">
    <AppSidebar :active-menu.sync="activeMenu" />

    <el-container>
      <el-header class="header">
        <div class="header-left">
          <i class="el-icon-document"></i>
          <span class="header-title">游客信息表</span>
        </div>

        <div class="header-right">
          <el-button type="primary" icon="el-icon-download" @click="onExport">导出游客数据</el-button>
          <el-button type="success" icon="el-icon-mobile-phone" @click="onExportPhone">导出手机号</el-button>
          <el-button type="info" icon="el-icon-upload" @click="onImportClick" :loading="importLoading">导入游客数据</el-button>
          <input ref="importInput" type="file" accept=".csv,.xls,.xlsx" style="display:none" @change="onFileChange" />
          <el-button type="danger" icon="el-icon-delete" @click="onClear">清空数据</el-button>
          <el-button icon="el-icon-refresh" @click="onRefresh">刷新数据</el-button>
        </div>
      </el-header>

      <el-main class="main">
        <!-- 筛选区 -->
        <el-card shadow="never" class="filter-card">
          <el-form :inline="true" size="small" class="filter-form">
            <el-form-item label="平台筛选：">
              <el-select v-model="filters.platform" placeholder="全部游客" style="width: 140px">
                <el-option label="全部游客" value="" />
                <el-option v-for="(p, idx) in platformOptions" :key="idx" :label="p" :value="p" />
              </el-select>
            </el-form-item>

            <el-form-item label="票种类型：">
              <el-select v-model="filters.ticketType" placeholder="全部类型" style="width: 140px">
                <el-option label="全部类型" value="" />
                <el-option v-for="(t, idx) in ticketTypeOptions" :key="idx" :label="t" :value="t" />
              </el-select>
            </el-form-item>

            <el-form-item label="游玩区域：">
              <el-select v-model="filters.area" placeholder="全部区域" style="width: 140px">
                <el-option label="全部区域" value="" />
                <el-option v-for="(a, idx) in areaOptions" :key="idx" :label="a" :value="a" />
              </el-select>
            </el-form-item>

            <el-form-item label="入园日期：">
              <!-- 入园日期改为下拉菜单，选项同样来源于系统设置中的 visitDates -->
              <el-select
                v-model="filters.visitDate"
                placeholder="选择入园日期"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(d, idx) in historyDates.filter(isFutureDate)"
                  :key="'visit-' + idx"
                  :label="formatHistoryLabel(d)"
                  :value="d"
                />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button class="clear-date-btn" @click="clearDate">清空日期</el-button>
            </el-form-item>

            <el-form-item label="渠道来源：">
              <el-select v-model="filters.channel" placeholder="全部渠道" style="width: 140px">
                <el-option label="全部渠道" value="" />
                <el-option v-for="(c, idx) in channelOptions" :key="'channel-' + idx" :label="c" :value="c" />
              </el-select>
            </el-form-item>

            <el-form-item label="订单号：">
              <el-input v-model="filters.orderNo" placeholder="输入订单号" style="width: 180px" />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="applyFilters">应用筛选</el-button>
              <el-button @click="resetFilters">清除筛选</el-button>
            </el-form-item>
            <el-form-item label="历史查询：">
              <!-- 历史查询改为下拉菜单，选项来源于系统设置中的 visitDates -->
              <el-select
                v-model="historyDate"
                placeholder="选择历史日期"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="(d, idx) in historyDates"
                  :key="idx"
                  :label="formatHistoryLabel(d)"
                  :value="d"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="applyHistory">历史查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 表格区 -->
        <el-card shadow="never" class="table-card">
          <el-table
            :data="filteredData"
            stripe
            border
            height="70vh"
            style="width: 100%"
            :header-cell-style="{ background: '#f5f7fa', color: '#303133', fontWeight: 700 }"
            :cell-style="{ padding: '10px 0' }"
            :row-class-name="rowClassName"
          >
            <el-table-column label="编号" width="80">
              <template slot-scope="scope">
                <div class="index-cell" :class="scope.row.groupPos">
                  <span v-if="scope.row.groupPos" class="group-bar" :class="scope.row.groupPos"></span>
                  <span class="index-text">{{ (page - 1) * pageSize + (scope.$index || 0) + 1 }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="订单号" prop="orderNo" min-width="160" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="order-no-cell" :class="scope.row.groupPos">
                  {{ scope.row.orderNo }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="游客姓名" min-width="110" />
            <el-table-column prop="idNo" label="证件号码" min-width="170" show-overflow-tooltip />
            <el-table-column prop="phone" label="手机号" min-width="120" />
            <el-table-column prop="age" label="年龄" width="80" />
            <el-table-column prop="visitDate" label="入园日期" min-width="110" />
            <el-table-column prop="platform" label="观礼平台" min-width="110">
              <template slot-scope="scope">
                <el-tag :style="{ background: platformColor(scope.row.platform), color: '#fff', borderRadius: '4px', padding: '2px 8px' }">
                  {{ scope.row.platform || '-' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="票种类型" min-width="100">
              <template slot-scope="scope">
                <el-tag :style="{ background: ticketTypeColor(scope.row.ticketType), color: '#fff', borderRadius: '4px', padding: '2px 8px' }">
                  {{ scope.row.ticketType || '-' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="area" label="游玩区域" min-width="100" />
            <el-table-column label="渠道来源" min-width="100">
              <template slot-scope="scope">
                <el-tag :style="{ background: channelColor(scope.row.channel), color: '#fff', borderRadius: '4px', padding: '2px 8px' }">
                  {{ channelText(scope.row.channel) || '-' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="supplier" label="供应商" min-width="100" />
            <el-table-column prop="talent" label="达人名称" min-width="100" />
            <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
            <el-table-column prop="createdAt" label="录入时间" min-width="160" />
            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onView(scope.row)">查看</el-button>
                <el-button type="text" size="small" class="danger-text" @click="onDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 空态：去掉多余的“暂无数据”四个字，只保留主要文案 -->
          <div v-if="filteredData.length === 0" class="empty">
            <div class="empty-icon">
              <i class="el-icon-coin"></i>
            </div>
            <div class="empty-title">暂无游客数据</div>
            <div class="empty-sub">请前往“游客信息录入”页面添加数据</div>
          </div>

          <div class="pager">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :current-page="page"
              :page-size="pageSize"
              :page-sizes="[10, 20, 50, 100, 200, 500]"
              @size-change="onPageSizeChange"
              @current-change="onPageChange"
            />
          </div>
        </el-card>
      </el-main>
    </el-container>

    <!-- 详情弹窗 -->
    <el-dialog title="游客详情" :visible.sync="detailVisible" width="720px">
      <el-descriptions v-if="detailRow" :column="2" border>
        <el-descriptions-item label="订单号">{{ detailRow.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="录入时间">{{ detailRow.createdAt }}</el-descriptions-item>

        <el-descriptions-item label="游客姓名">{{ detailRow.name }}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{ detailRow.age }}</el-descriptions-item>

        <el-descriptions-item label="证件号码" :span="2">{{ detailRow.idNo }}</el-descriptions-item>

        <el-descriptions-item label="手机号">{{ detailRow.phone }}</el-descriptions-item>
        <el-descriptions-item label="入园日期">{{ detailRow.visitDate }}</el-descriptions-item>

        <el-descriptions-item label="观礼平台">{{ detailRow.platform }}</el-descriptions-item>
        <el-descriptions-item label="票种类型">{{ detailRow.ticketType }}</el-descriptions-item>

        <el-descriptions-item label="游玩区域">{{ detailRow.area }}</el-descriptions-item>
        <el-descriptions-item label="渠道来源">{{ channelText(detailRow.channel) }}</el-descriptions-item>

        <el-descriptions-item label="供应商">{{ detailRow.supplier }}</el-descriptions-item>
        <el-descriptions-item label="达人名称">{{ detailRow.talent }}</el-descriptions-item>

        <el-descriptions-item label="核销状态">{{ detailRow.verifyStatus }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailRow.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import AppSidebar from '../../components/AppSidebar.vue'
import { clearVisitors, deleteVisitor, getVisitors, getSettings, importVisitors } from '../../api'
import { PLATFORMS, PLATFORM_AREAS } from '../../config/platforms'
import { buildQuery, downloadByUrl } from '../../utils/download'
import { API_BASE } from '../../api/http'

export default {
  name: 'VisitorListPage',
  components: { AppSidebar },
      data() {
    return {
      activeMenu: '2',
      loading: false,
      importLoading: false,
      tableData: [],
      platformColorsMap: {},
      total: 0,
      page: 1,
      pageSize: 20,
      filters: {
        platform: '',
        ticketType: '',
        area: '',
        visitDate: '',
        orderNo: '',
        channel: ''
      },
      detailVisible: false,
      detailRow: null,
      // settings-driven options
      platformOptions: [],
      ticketTypeOptions: [],
      areaOptions: [],
      channelOptions: [],
      historyDate: '',
      historyDates: []
    }
  },
  computed: {
    filteredData() {
      // 后端已支持筛选，这里直接展示 tableData；保留 computed 以兼容模板字段
      return this.tableData
    }
  },
  created() {
    this.loadData()
    this.loadSettings()
  },
  methods: {
    async loadSettings() {
      try {
        const data = await getSettings()
        const visitor = (data && data.visitor) || {}
        this._ticketTypeColors = visitor.ticketTypeColors || {}
        this._channelColors = visitor.channelColors || {}
        this.platformColorsMap = visitor.platformColors || {}
        this.historyDates = visitor.visitDates || []
        if (this.historyDates.length > 0 && !this.historyDate) this.historyDate = this.historyDates[0]

        // 平台统一使用前端固定平台
        this.platformOptions = PLATFORMS.slice()
        this.ticketTypeOptions = Array.isArray(visitor.ticketTypeOptions) ? visitor.ticketTypeOptions : (visitor.ticketTypeOptions || [])

        // 渠道选项从系统设置中读取
        this.channelOptions = Array.isArray(visitor.channelOptions) ? visitor.channelOptions : (visitor.channelOptions || [])

        // 游玩区域使用前端固定 PLATFORM_AREAS（不再使用后端 areaOptions）
        this.areaOptions = []
        Object.keys(PLATFORM_AREAS).forEach(p => {
          const arr = PLATFORM_AREAS[p] || []
          this.areaOptions.push(...arr)
        })
        this.areaOptions = Array.from(new Set(this.areaOptions))
      } catch (e) {
        this._ticketTypeColors = {}
        this._channelColors = {}
        this.platformOptions = []
        this.ticketTypeOptions = []
        this.channelOptions = []
        this.areaOptions = []
      }
    },
    async onImportClick() {
      // trigger file input
      const el = this.$refs.importInput
      if (el && el.click) el.click()
    },
    async onFileChange(e) {
      const files = e.target.files || []
      if (!files.length) return
      const file = files[0]
      // basic validation
      const allowed = ['csv', 'xls', 'xlsx']
      const name = file.name || ''
      const ext = name.split('.').pop().toLowerCase()
      if (!allowed.includes(ext)) {
        this.$message.error('只支持 CSV / XLS / XLSX 文件')
        e.target.value = ''
        return
      }

      const fd = new FormData()
      fd.append('file', file)

      try {
        this.importLoading = true
        // call API (importVisitors added in api/index.js)
        const res = await importVisitors(fd)
        // res contains summary: successOrders, failedOrders, details
        const succ = res.successOrders || 0
        const fail = res.failedOrders || 0
        this.$message.success(`导入完成：成功 ${succ} 个订单，失败 ${fail} 个订单`)
        // optionally show details in console
        console.log('import details', res.details || [], res.errors || [])

        // 如果存在订单号重复的项，弹窗提示用户（可能存在多个）
        const details = res.details || []
        const dupItems = details.filter(d => d.error && String(d.error).includes('订单号重复'))
        if (dupItems.length > 0) {
          const orderList = dupItems.map(d => d.orderNo).slice(0, 20).join(', ')
          const more = dupItems.length > 20 ? ` 等 ${dupItems.length} 个` : ''
          this.$alert(`导入过程中检测到重复订单号：${orderList}${more}，请检查并修正后重新导入。`, '订单号重复', {
            type: 'warning'
          })
        }

        await this.loadData()
      } catch (err) {
        this.$message.error(err.message || '导入失败')
      } finally {
        this.importLoading = false
        e.target.value = ''
      }
    },
    disabledHistoryDate(date) {
      if (!date) return true
      try {
        const y = date.getFullYear()
        const m = String(date.getMonth() + 1).padStart(2, '0')
        const d = String(date.getDate()).padStart(2, '0')
        const s = `${y}/${m}/${d}`
        return !(this.historyDates || []).includes(s)
      } catch (e) {
        return true
      }
    },
    formatHistoryLabel(d) {
      // display as yyyy.MM.dd
      try {
        const s = String(d).replace(/\//g, '-')
        const dt = new Date(s)
        if (isNaN(dt.getTime())) return d
        const y = dt.getFullYear()
        const m = String(dt.getMonth() + 1).padStart(2, '0')
        const day = String(dt.getDate()).padStart(2, '0')
        return `${y}.${m}.${day}`
      } catch (e) {
        return d
      }
    },
    isFutureDate(d) {
      // 判断日期是否为当前日期及以后
      try {
        const s = String(d).replace(/\//g, '-')
        const dt = new Date(s)
        if (isNaN(dt.getTime())) return false
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        dt.setHours(0, 0, 0, 0)
        return dt >= today
      } catch (e) {
        return false
      }
    },
    applyHistory() {
      if (!this.historyDate) {
        this.$message.warning('请先选择历史日期')
        return
      }
      this.filters.visitDate = this.historyDate
      this.applyFilters()
    },
    onPageChange(p) {
      this.page = p
      this.loadData()
    },
    onPageSizeChange(ps) {
      this.pageSize = ps
      this.page = 1
      this.loadData()
    },
    channelText(v) {
      const map = {
        online: '线上',
        offline: '线下',
        agency: '旅行社'
      }
      return map[v] || v || ''
    },
    ticketTypeColor(t) {
      if (!t) return '#909399'
      // exact match
      if (this._ticketTypeColors && this._ticketTypeColors[t]) return this._ticketTypeColors[t]
      // try loose matching (e.g. stored key '成人票' vs value '成人')
      if (this._ticketTypeColors) {
        for (const k of Object.keys(this._ticketTypeColors)) {
          if (!k) continue
          if (String(k).includes(t) || String(t).includes(k)) {
            return this._ticketTypeColors[k]
          }
        }
      }
      // fallback defaults
      const map = { '成人': '#409EFF', '儿童': '#67C23A', '免票': '#909399' }
      return map[t] || '#909399'
    },
    channelColor(c) {
      if (!c) return '#909399'
      // prefer match by display text
      const disp = this.channelText(c)
      if (this._channelColors && this._channelColors[disp]) return this._channelColors[disp]
      // try loose matching on keys
      if (this._channelColors) {
        for (const k of Object.keys(this._channelColors)) {
          if (!k) continue
          if (String(k).includes(disp) || String(disp).includes(k) || String(k).includes(c) || String(c).includes(k)) {
            return this._channelColors[k]
          }
        }
      }
      const map = { online: '#409EFF', offline: '#67C23A', agency: '#E6A23C' }
      return map[c] || '#909399'
    },
    platformColor(p) {
      if (!p) return '#909399'
      if (this.platformColorsMap && this.platformColorsMap[p]) return this.platformColorsMap[p]
      // try loose matching as fallback
      if (this.platformColorsMap) {
        for (const k of Object.keys(this.platformColorsMap)) {
          if (!k) continue
          if (String(k).includes(p) || String(p).includes(k)) {
            return this.platformColorsMap[k]
          }
        }
      }
      return '#409EFF'
    },
    async loadData() {
      this.loading = true
      try {
        const data = await getVisitors({
          ...this.filters,
          page: this.page,
          pageSize: this.pageSize
        })
        const list = data.list || []
        // 标注分组信息：groupPos = 'single'|'start'|'middle'|'end'
        const annotated = list.map((r, i, arr) => {
          const prev = i > 0 ? arr[i - 1].orderNo : null
          const next = i < arr.length - 1 ? arr[i + 1].orderNo : null
          const start = prev !== r.orderNo
          const end = next !== r.orderNo
          let pos = ''
          if (start && end) pos = 'single'
          else if (start) pos = 'start'
          else if (end) pos = 'end'
          else pos = 'middle'
          return { ...r, groupPos: pos }
        })
        this.tableData = annotated
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },

    rowClassName(row) {
      // Element table calls rowClassName(row, index)
      const r = row && row.row ? row.row : row
      if (!r || !r.groupPos) return ''
      // only highlight start or single rows
      if (r.groupPos === 'start' || r.groupPos === 'single') return 'order-group-row ' + r.groupPos
      return ''
    },
    clearDate() {
      this.filters.visitDate = ''
    },
    async applyFilters() {
      this.page = 1
      await this.loadData()
      this.$message.success('已应用筛选')
    },
    async resetFilters() {
      this.filters = { platform: '', ticketType: '', area: '', visitDate: '', orderNo: '', channel: '' }
      this.page = 1
      await this.loadData()
    },
    onExport() {
      // 导出当前筛选条件下的所有数据（后端不分页）
      const url = `${API_BASE}/api/export/visitors.csv${buildQuery(this.filters)}`
      downloadByUrl(url)
    },
    onExportPhone() {
      const url = `${API_BASE}/api/export/phones.txt${buildQuery(this.filters)}`
      downloadByUrl(url)
    },
    onDownloadTemplate() {
      const url = `${API_BASE}/api/visitors/template`
      downloadByUrl(url)
    },
    onClear() {
      // 先获取符合条件的数量
      this.$message.info('正在统计...')
      getVisitors({ ...this.filters, page: 1, pageSize: 1 })
        .then(data => {
          const count = data.total || 0
          if (count === 0) {
            this.$message.warning('没有符合条件的数据可清空')
            return
          }
          this.$confirm(`确认清空当前筛选条件下的 ${count} 条游客数据？`, '提示', { type: 'warning' })
            .then(async () => {
              await clearVisitors(this.filters)
              await this.loadData()
              this.$message.success('已清空')
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message.error('获取数据失败')
        })
    },
    async onRefresh() {
      await this.loadData()
      this.$message.success('已刷新')
    },
    onView(row) {
      this.detailRow = row
      this.detailVisible = true
    },
    onDelete(index) {
      this.$confirm('确认删除该条记录？', '提示', { type: 'warning' })
        .then(async () => {
          const row = this.filteredData[index]
          await deleteVisitor(row.visitorId)
          await this.loadData()
          this.$message.success('已删除')
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.page {
  height: 100vh;
  background: #f5f7fa;
}

.header {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #303133;
}

.header-title {
  font-size: 18px;
  font-weight: 700;
}

.main {
  padding: 16px;
}

.filter-card {
  margin-bottom: 16px;
}

.filter-form ::v-deep .el-form-item {
  margin-right: 16px;
  margin-bottom: 10px;
}

.clear-date-btn {
  width: 72px;
  height: 32px;
  padding: 0 10px;
  line-height: 32px;
  border-radius: 4px;
  border: none;
  color: #fff;
  background: #606266;
  white-space: nowrap;
}

.clear-date-btn:hover {
  background: #4e5258;
}

.table-card {
  position: relative;
}

.pager {
  padding: 12px 0 4px;
  display: flex;
  justify-content: flex-end;
}

.danger-text {
  color: #f56c6c;
}

.empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-10%);
  text-align: center;
  color: #909399;
}

.empty-icon {
  font-size: 56px;
  color: #dcdfe6;
}

.empty-title {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
}

.empty-sub {
  margin-top: 6px;
  font-size: 12px;
}

/* 订单号分组样式 */
.order-no-cell {
  padding-left: 12px;
  height: 36px;
  display: flex;
  align-items: center;
}
.order-no-cell.start,
.order-no-cell.single {
  border-left: 4px solid #409EFF;
}
.order-no-cell.start {
  border-top-left-radius: 6px;
  padding-top: 8px;
}
.order-no-cell.end {
  padding-bottom: 8px;
}
.order-no-cell.single {
  border-radius: 6px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.order-group-row.start {
  background: #f5fbff;
}
.order-group-row.single {
  background: #f5fbff;
}
/* scoped 样式可能无法作用到 el-table 内部生成的 tr/td，
   使用 deep 选择器让样式强制生效并作用到单元格 */
::v-deep .el-table__body tr.order-group-row.start > td,
::v-deep .el-table__body tr.order-group-row.single > td {
  background: #f5fbff !important;
}

/* 覆盖：移除 order-no-cell 的左侧蓝条（已迁移到编号列） */
.order-no-cell.start,
.order-no-cell.single {
  border-left: none !important;
}

/* 编号列蓝色竖条样式（显示在编号前） */
.index-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.group-bar { display: none; }
.index-text {
  color: #606266;
}

/* 把蓝色左侧竖条作为整行左边框显示（作用到 el-table 生成的 td） */
::v-deep .el-table__body tr.order-group-row.start > td:first-child,
::v-deep .el-table__body tr.order-group-row.middle > td:first-child,
::v-deep .el-table__body tr.order-group-row.end > td:first-child,
::v-deep .el-table__body tr.order-group-row.single > td:first-child {
  border-left: 4px solid #409EFF !important;
  padding-left: 12px !important;
}
::v-deep .el-table__body tr.order-group-row.start > td:first-child {
  border-top-left-radius: 6px !important;
}
::v-deep .el-table__body tr.order-group-row.end > td:first-child {
  border-bottom-left-radius: 6px !important;
}

</style>
